import i18n from "../../../../i18n"
import { DTO_Weather } from "../../../../services/calls/types/maps"

enum DATA_ID {
  ROAD_NAME = 'road_name',
  ROAD_ICON = 'road_icon',
  ROAD_DESCR = 'road_description',
  POINT_TYPE = 'point_title',
  POINT_DESCR_IS = 'point_description_is',
  POINT_DESCR_EN = 'point_description_en',
  POINT_VALID_FROM = 'point_valid_from',
  POINT_VALID_TO = 'point_valid_to',
  WEATHER_NAME = 'weather_name',
  WEATHER_DATE = 'weather_date',
  WEATHER_WIND = 'weather_wind',
  WEATHER_GUSTS = 'weather_gusts',
  WEATHER_HEAT = 'weather_heat',
  WEATHER_ROAD_HEAD = 'weather_road_head',
  WEATHER_HUMIDITY = 'weather_humidity',
  WEATHER_DEW_POINT = 'weather_dew_point',
  CAMERA_LOCATION = 'camera_location',
  CAMERA_IMG = 'camera_img'
}

export const MAP_DATA = {
  [DATA_ID.ROAD_NAME]: {
    id: DATA_ID.ROAD_NAME,
    label: i18n.t('Road name'),
    path: 'road_name'
  },
  [DATA_ID.ROAD_ICON]: {
    id: DATA_ID.ROAD_ICON,
    label: i18n.t('Road icon'),
    path: 'road_colors',
  },
  [DATA_ID.ROAD_DESCR]: {
    id: DATA_ID.ROAD_DESCR,
    label: i18n.t('Road description'),
    path: 'road_description'
  },
  [DATA_ID.POINT_TYPE]: {
    id: DATA_ID.POINT_TYPE,
    label: i18n.t('Point type'),
    path: 'point_title_is'
  },
  [DATA_ID.POINT_DESCR_IS]: {
    id: DATA_ID.POINT_DESCR_IS,
    label: `${i18n.t('Point description')} (${i18n.t('Icelandic')})`,
    path: 'point_description_is'
  },
  [DATA_ID.POINT_DESCR_EN]: {
    id: DATA_ID.POINT_DESCR_EN,
    label: `${i18n.t('Point description')} (${i18n.t('English')})`,
    path: 'point_description_en'
  },
  [DATA_ID.POINT_VALID_FROM]: {
    id: DATA_ID.POINT_VALID_FROM,
    label: i18n.t('Valid from'),
    path: 'point_valid_from',
    type: 'datetime'
  },
  [DATA_ID.POINT_VALID_TO]: {
    id: DATA_ID.POINT_VALID_TO,
    label: i18n.t('Valid to'),
    path: 'point_valid_to',
    type: 'datetime'
  },
  [DATA_ID.WEATHER_NAME]: {
    id: DATA_ID.WEATHER_NAME,
    label: i18n.t('Location'),
    path: 'Nafn'
  },
  [DATA_ID.WEATHER_DATE]: {
    id: DATA_ID.WEATHER_DATE,
    label: i18n.t('Date'),
    path: 'Dags'
  },
  [DATA_ID.WEATHER_WIND]: {
    id: DATA_ID.WEATHER_WIND,
    label: i18n.t('Wind'),
    path: 'Vindhradi',
    formatFunction: (value: any, data: DTO_Weather) => {
      const lang = i18n.language
      const direction = (lang === 'en' ? data.VindattAscEng : data.VindattAsc).replace(/ /g, "")
      return `${direction}, ${data.Vindhradi} m/s`
    }
  },
  [DATA_ID.WEATHER_GUSTS]: {
    id: DATA_ID.WEATHER_GUSTS,
    label: i18n.t('Gusts'),
    path: 'Vindhvida',
    formatFunction: (value: any, data: DTO_Weather) => `${value} m/s`
  },
  [DATA_ID.WEATHER_HEAT]: {
    id: DATA_ID.WEATHER_GUSTS,
    label: i18n.t('Heat'),
    path: 'Hiti',
    formatFunction: (value: any, data: DTO_Weather) => `${value}˚C`
  },
  [DATA_ID.WEATHER_ROAD_HEAD]: {
    id: DATA_ID.WEATHER_ROAD_HEAD,
    label: i18n.t('Road head'),
    path: 'Veghiti',
    formatFunction: (value: any, data: DTO_Weather) => `${value}˚C`
  },
  [DATA_ID.WEATHER_HUMIDITY]: {
    id: DATA_ID.WEATHER_HUMIDITY,
    label: i18n.t('Humidity'),
    path: 'Raki',
    formatFunction: (value: any, data: DTO_Weather) => `${value}%`
  },
  [DATA_ID.WEATHER_DEW_POINT]: {
    id: DATA_ID.WEATHER_DEW_POINT,
    label: i18n.t('Dew point'),
    path: 'Daggarmark'
  },
  [DATA_ID.CAMERA_LOCATION]: {
    id: DATA_ID.CAMERA_LOCATION,
    label: i18n.t('Location'),
    path: 'name'
  },
  [DATA_ID.CAMERA_IMG]: {
    id: DATA_ID.CAMERA_IMG,
    label: null,
    path: 'img',
    type: 'img'
  }
}

export const MAP_ITEM_INFO = {
  roadConditions: {
    label: i18n.t('Road condition'),
    infoArr: [
      MAP_DATA[DATA_ID.ROAD_NAME], MAP_DATA[DATA_ID.ROAD_ICON],
      MAP_DATA[DATA_ID.ROAD_DESCR]
    ]
  },
  roadSigns: {
    label: i18n.t('Road point information'),
    infoArr: [
      MAP_DATA[DATA_ID.POINT_TYPE], MAP_DATA[DATA_ID.POINT_DESCR_IS],
      MAP_DATA[DATA_ID.POINT_DESCR_EN], MAP_DATA[DATA_ID.POINT_VALID_FROM],
      MAP_DATA[DATA_ID.POINT_VALID_TO]
    ]
  },
  weather: {
    label: i18n.t('Weather'),
    infoArr: [
      MAP_DATA[DATA_ID.WEATHER_NAME], MAP_DATA[DATA_ID.WEATHER_DATE],
      MAP_DATA[DATA_ID.WEATHER_WIND], MAP_DATA[DATA_ID.WEATHER_GUSTS],
      MAP_DATA[DATA_ID.WEATHER_HEAT], MAP_DATA[DATA_ID.WEATHER_ROAD_HEAD],
      MAP_DATA[DATA_ID.WEATHER_HUMIDITY], MAP_DATA[DATA_ID.WEATHER_DEW_POINT]
    ]
  },
  liveCams: {
    label: i18n.t('Livecam'),
    infoArr: [
      MAP_DATA[DATA_ID.CAMERA_LOCATION], MAP_DATA[DATA_ID.CAMERA_IMG]
    ]
  }
}
